<template>
    <button v-if="content"
        :data-tooltip="content"
        :data-tippy-maxwidth="tooltipMaxWidth"
        type="button"
        class="text-muted cursor-help focus:outline-none"
    >
        <slot name="trigger">
            <icon name="help-circle"/>
        </slot>
        <span class="content hidden">
            <slot></slot>
        </span>
    </button>
</template>

<script>
export default {
    props: [
        'tooltip',
        'tooltipMaxWidth'
    ],

    data() {
        return {
            content: '<em>content not set</em>',
        }
    },

    methods: {
        getTooltipContentFromSlot() {
            return this.$el.getElementsByClassName('content')[0].innerHTML;
        }
    },

    mounted() {
        this.content = window.App.tooltips[this.tooltip] || this.getTooltipContentFromSlot();
    }
}
</script>
